import { useEffect, useState } from 'react';

export const DELIVERY_MODE_KEY = 'geppetto_delivery_mode';
export const DELIVERY_MODE_EVENT = 'geppetto-delivery-mode';

/** Elementos que só fazem sentido na página do site, não no ZIP de curso. */
export const SITE_ONLY_WIDGET_TYPES = ['site-menu', 'site-footer', 'site-login', 'site-maintenance'];

export function isSiteOnlyWidget(type) {
  return SITE_ONLY_WIDGET_TYPES.includes(type);
}

export function readDeliveryMode() {
  try {
    return localStorage.getItem(DELIVERY_MODE_KEY) === 'site' ? 'site' : 'course';
  } catch {
    return 'course';
  }
}

export function setDeliveryMode(mode) {
  const next = mode === 'site' ? 'site' : 'course';
  try {
    localStorage.setItem(DELIVERY_MODE_KEY, next);
  } catch {
    /* a sessão atual ainda recebe o evento */
  }
  window.dispatchEvent(new CustomEvent(DELIVERY_MODE_EVENT, { detail: next }));
  return next;
}

export function useDeliveryMode() {
  const [mode, setMode] = useState(readDeliveryMode);

  useEffect(() => {
    const onChange = (event) => {
      setMode(event.detail === 'site' ? 'site' : 'course');
    };
    const onStorage = (event) => {
      if (event.key === DELIVERY_MODE_KEY) setMode(readDeliveryMode());
    };
    window.addEventListener(DELIVERY_MODE_EVENT, onChange);
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener(DELIVERY_MODE_EVENT, onChange);
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  return mode;
}
